import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-12260b31"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "headNav"
};
var _hoisted_2 = {
  class: "nav"
};
var _hoisted_3 = {
  class: "nav-head"
};
var _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 顶部切换导航 "), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createCommentVNode(" 新歌速递/新碟上架 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navHead, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['nav-title', _ctx.isHead == item && 'active']),
      key: item,
      onClick: function onClick($event) {
        return _ctx.navHeadClick(item);
      }
    }, _toDisplayString(item), 11
    /* TEXT, CLASS, PROPS */
    , _hoisted_4);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])]);
}